import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { formatDate } from '../../utils/utilities';

const ClinicalTaskModal = ({show, setShow, data}) => {

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Clinical Task Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-between gap-3 justify-content-center h-100">
                    <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center w-25 h-25 mt-5">
                        <i class="ri-capsule-fill fs-1"></i>
                    </div>
                    <div>
                        <div className="mb-0">
                            <label className=''>Task</label>
                            <p className='fs-sm text-danger'>
                                {data?.title ?? '---'}
                            </p>
                        </div>
                        <div className="mb-0">
                            <label className=''>Set By</label>
                            <p className='fs-sm'>
                                {data?.createdBy ?? '---'}
                            </p>
                        </div>
                        <div className="mb-0">
                            <label className=''>Start Time</label>
                            <p className='fs-sm text-primary'>
                                {formatDate( data?.startTime?? "---")}
                            </p>
                        </div>
                        
                        {/* <div className="mb-0">
                            <label className=''>Last Time Attended</label>
                            <p className='fs-sm'>
                                ---
                            </p>
                        </div> */}
                        <h6 className="mb-0">
                            <label className=''>Next Due Date</label>
                            <p className='fs-sm text-primary'>
                                {formatDate( data?.nextTime?? "---")}  
                            </p>
                        </h6>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {/* <Button variant="primary" onClick={handleClose}>
                    Yes! Verify
                </Button>
                */}
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button> 
            </Modal.Footer>
        </Modal>
    )
}

export default ClinicalTaskModal
// 